export default __webpack_public_path__ + "static/media/deploy.17877c36.svg";